module.exports = __webpack_public_path__ + "media/images/gallery/constellations/order_layer_off-89d56db9366631b0c741263b596c1d90.png";